export const REFUND_AMOUNT_FIELDS = [
  { key: "actual_refund_amount", label: "실제 환불액" },
  { key: "used_points", label: "포인트 사용액" },
  { key: "used_credits", label: "예치금 사용액" },
] as const;

export type RefundAmountField = (typeof REFUND_AMOUNT_FIELDS)[number]["key"];

export interface RefundAmountBreakdown {
  [key: string]: number;
}

function readAmount(value: unknown): number {
  if (typeof value === "number" && Number.isFinite(value)) {
    return Math.max(0, value);
  }
  if (typeof value !== "string") return 0;
  const amount = Number(value.replace(/,/g, "").trim());
  return Number.isFinite(amount) ? Math.max(0, amount) : 0;
}

export function summarizeRefundAmounts(refunds: any[]): {
  amount: number;
  breakdown: RefundAmountBreakdown;
} {
  const breakdown: RefundAmountBreakdown = Object.fromEntries(
    REFUND_AMOUNT_FIELDS.map(({ key }) => [key, 0])
  );

  for (const refund of Array.isArray(refunds) ? refunds : []) {
    for (const { key } of REFUND_AMOUNT_FIELDS) {
      breakdown[key] += readAmount(refund?.[key]);
    }
  }

  return {
    amount: -Object.values(breakdown).reduce((sum, value) => sum + value, 0),
    breakdown,
  };
}
